import ApplicationStatusModal from './ApplicationStatusModal.svelte';

const applicationStatusModalOptions = {
    styleWindow: {
        borderRadius: '0',
    },
    styleContent: {
        padding: 0,
    },
    closeButton: false,
    closeOnEsc: false,
    closeOnOuterClick: false,
};

export { applicationStatusModalOptions, ApplicationStatusModal };
